module.exports = __webpack_public_path__ + "static/media/mix.965fa296.png";